import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/materialtype',
  component: () => import('@views/MaterialType/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'materialtype.index',
      component: () => import('@/components/MaterialType/MaterialType')
    },
  ]
}
